import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="mt-8 border-t bg-background/50">
      <div className="container mx-auto flex max-w-5xl flex-col items-center gap-2 px-4 py-6 text-center text-sm text-muted-foreground">
        <p className="max-w-md">
          All balances, prices, fees, and transactions in BCH School are{" "}
          <strong className="text-foreground">simulated</strong> for learning.
          No real money is ever involved.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
          <Link to="/badges" className="hover:text-primary transition-colors">
            Badges
          </Link>
          <Link to="/glossary" className="hover:text-primary transition-colors">
            Glossary
          </Link>
          <Link to="/certificate" className="hover:text-primary transition-colors">
            Certificate
          </Link>
          <a
            href="https://shakespeare.diy"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-primary transition-colors"
          >
            Vibed with Shakespeare
          </a>
        </div>
      </div>
    </footer>
  );
}
